import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { applicationsActivationsValidateSearchSchema } from '../../common/applicationsActivations/applicationsActivationsValidateSearchSchema';
import { serviceSettingsRoute } from '../route';

export const activateApplicationsRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/activate-applications',
	component: lazyRouteComponent(
		() => import('./ActivateApplicationsPage'),
		'ActivateApplicationsPage',
	),
	validateSearch: applicationsActivationsValidateSearchSchema,
});
